export const Colors = {
  background: '#201624',

  checkboardBlack: "#f9f9f9",
  checkboardWhite: "white",

  valid: '#2af548',
  error: '#ba2039'
}